import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import HourTypeInput from "../../../../components/reports/time-period-input/hour-type-input.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters }) {
    const { pclNames } = useReportFiltersFetch({ fetchPclNames: true });

    const periodOptions = [
        { value: "all", label: "Definido pelo usuário" },
        { value: "dawn", label: "Madrugada" },
        { value: "morning", label: "Manhã" },
        { value: "afternoon", label: "Tarde" },
        { value: "evening", label: "Noite" },
    ];

    return (
        <div className={`mb-2 ${minMenuHeight}`}>
            <form className="space-y-4">
                <InputDateTime
                    id="dtStart"
                    label="Data inicial *"
                    dateFormat="L"
                    classNameWrapper="w-full"
                    selected={filters.dtStart ? new Date(filters.dtStart) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                />
                <InputDateTime
                    id="dtEnd"
                    label="Data final *"
                    dateFormat="L"
                    classNameWrapper="w-full"
                    selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                />
                <HourTypeInput
                    filters={filters}
                    setFilters={setFilters}
                />
                <SelectComponent
                    id="laneA"
                    label="Câmera A *"
                    classNameWrapper="w-full"
                    wrapValue={true}
                    isMulti={false}
                    options={pclNames}
                    value={filters.laneA}
                    onChange={(value) => setFilters(prev => ({ ...prev, laneA: value }))}
                />
                <SelectComponent
                    id="laneB"
                    label="Câmera B *"
                    classNameWrapper="w-full"
                    wrapValue={true}
                    isMulti={false}
                    options={pclNames}
                    value={filters.laneB}
                    onChange={(value) => setFilters(prev => ({ ...prev, laneB: value }))}
                />
            </form>
        </div>
    )
}